import axios from 'axios'

export const configData = {
    getConfigData (ver) {
        const defaultConfigData = this.getDefaultConfigData()
        const staticConfigData = this.getStaticConfigData()
        return axios.get(process.env.VUE_APP_CONFIG_ENDPOINT)
            .then(({ data }) => {
                return {
                    ...defaultConfigData,
                    ...data[ver],
                    ...staticConfigData
                }
            }).catch(function (error) {
                if (error) {
                    return defaultConfigData
                }
            })
    },
    getStaticConfigData () {
        return {
            defaultAmounts: this.getJsonValue(process.env.VUE_APP_DEFAULT_PAYMENT_FORM_DEFAULT_AMOUNTS)
        }
    },
    getDefaultConfigData () {
        const languageNavigationItems = this.getLanguageNavigationItems()
        const hasLanguageNavigationItems = languageNavigationItems.length > 0

        return {
            headerText: process.env.VUE_APP_DEFAULT_PAYMENT_FROM_HEADER_TEXT,
            mainText: process.env.VUE_APP_DEFAULT_PAYMENT_FORM_MAIN_TEXT,
            backgroundImage: process.env.VUE_APP_DEFAULT_PAYMENT_FORM_BACKGROUND_IMAGE,
            backgroundImageMobile: process.env.VUE_APP_DEFAULT_PAYMENT_FORM_BACKGROUND_IMAGE_MOBILE,
            backgroundText: process.env.VUE_APP_DEFAULT_PAYMENT_FORM_BACKGROUND_TEXT,
            defaultAmount: parseInt(process.env.VUE_APP_DEFAULT_PAYMENT_FORM_DEFAULT_AMOUNT),
            paymentTilesOrder: JSON.parse(process.env.VUE_APP_DEFAULT_PAYMENT_FORM_PAYMENT_TILES_ORDER),
            languageNavigationItems: languageNavigationItems,
            hasLanguageNavigationItems: hasLanguageNavigationItems
        }
    },
    getJsonValue (option) {
        try {
            return JSON.parse(option)
        } catch (e) {
            return []
        }
    },
    getLanguageNavigationItems () {
        const enableLanguageNavBar = process.env.VUE_APP_LANGUAGE_NAV_BAR

        if (enableLanguageNavBar !== 'true') {
            return []
        }

        let languageItems = []

        if (process.env.VUE_APP_LANGUAGE_NAV_BAR_ITEM_ENGLISH === 'true') {
            languageItems.push(this.getEnglishNavigationItem())
        }

        return languageItems
    },
    getEnglishNavigationItem () {
        return {
            id: 'en',
            link: {
                href: process.env.VUE_APP_LANGUAGE_NAV_BAR_ITEM_ENGLISH_LINK_HREF,
                title: process.env.VUE_APP_LANGUAGE_NAV_BAR_ITEM_ENGLISH_LINK_TITLE,
                text: process.env.VUE_APP_LANGUAGE_NAV_BAR_ITEM_ENGLISH_LINK_TEXT
            },
            flag: {
                filename: process.env.VUE_APP_LANGUAGE_NAV_BAR_ITEM_ENGLISH_FLAG_FILENAME,
                alt: process.env.VUE_APP_LANGUAGE_NAV_BAR_ITEM_ENGLISH_FLAG_ALT
            }
        }
    }
}
